/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';
import 'leaflet-control-geocoder';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { logger } from 'utils/debug';
import { Col, Form, Input } from 'antd';
import { toFixed } from 'utils/normalizers';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const MapContainer = styled.div`
  width: 100%;
  height: 500px;
  border-radius: 4px;
  overflow: hidden;

  .leaflet-container {
    height: 100%;
  }
`;

const OSMap = ({
  center = [20.4737, -103.4469],
  zoom = 15,
  onLocationSelect,
  latitud: _latitud,
  longitud: _longitud,
}) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);
  const formInstance = Form.useFormInstance();

  const _setMarker = (map, latLng, name = null) => {
    if (markerRef.current) map.removeLayer(markerRef.current);

    const marker = L.marker(latLng).addTo(map);
    if (name) marker.bindPopup(name).openPopup();
    markerRef.current = marker;
  };

  useEffect(() => {
    if (!mapRef.current) return null;

    const map = L.map(mapRef.current).setView(center, zoom);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
      maxZoom: 19,
    }).addTo(map);

    L.Control.geocoder({ defaultMarkGeocode: false }).on('markgeocode', (result) => {
      const latLng = result.geocode.center;
      _setMarker(map, latLng, result.geocode.name);

      if (onLocationSelect) {
        onLocationSelect({
          lat: latLng.lat,
          lng: latLng.lng,
          name: result.geocode.name,
        });
      }
    }).addTo(map);

    map.on('click', async (e) => {
      const { lat, lng } = e.latlng;

      try {
        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`);
        const data = await response.json();

        _setMarker(map, e.latlng, data?.display_name);
        if (onLocationSelect) onLocationSelect({ lat, lng, name: data?.display_name });
        if (formInstance) {
          formInstance.setFieldsValue({ latitud: toFixed(lat, 4), longitud: toFixed(lng, 4) });
        }
      } catch (error) {
        logger('Error reverse geocoding:', error);
      }
    });

    mapInstanceRef.current = map;

    return () => {
      map.remove();
    };
  }, [center, zoom, onLocationSelect]);

  useEffect(() => {
    if (mapInstanceRef.current && _latitud !== undefined && _longitud !== undefined) {
      const latLng = [_latitud, _longitud];
      mapInstanceRef.current.setView(latLng, 15);
      _setMarker(mapInstanceRef.current, latLng);
    }
  }, [_latitud, _longitud]);

  return (
    <>
      <Col xs={24} sm={24} md={8}>
        <Form.Item label="Latitud" name="latitud">
          <Input allowClear />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item label="Longitud" name="longitud">
          <Input allowClear />
        </Form.Item>
      </Col>
      <Col span={24} />
      <MapContainer ref={mapRef} />
    </>
  );
};

export default OSMap;
